import Chroma from 'chroma-js';

const defaultPartyColumns = [
  'CDU',
  'Die.Linke',
  'SPD',
  'AfD',
  'Grüne',
  'Die.Partei',
  'Piraten',
  'Gesundheitsforschung',
  'ÖDP',
  'Tierschutz.hier',
  'Tierschutzpartei',
  'Freie.Wähler',
  'Die.Humanisten',
  'Volt'
];

export const partyColumns = ARTICLE_CONFIG.partyColumns || defaultPartyColumns;

export const partyColumnsComp = partyColumns.map(c => `${c}_Vergleich`);
export const invalidVotesColumn = 'Ungültige.Stimmzettel';
export const Voters = 'Wähler';
export const countStatus = 'Stand';
export const invalidVotesColumnComp = `Ungültige.Stimmen_Vergleich`;
export const validVotesColumn = 'Gültige.Stimmen';
export const validVotesColumnComp = `${validVotesColumn}_Vergleich`;
export const allVotesColumn = 'Wahlberechtigte';
export const allVotesColumnComp = `${allVotesColumn}_Vergleich`;
export const topParties = partyColumns.slice(0, 6);
//export const cduShortName = 'CDU';

export const numColumns = [
  ...partyColumns,
  ...partyColumnsComp,
  invalidVotesColumn,
  invalidVotesColumnComp,
  validVotesColumn,
  Voters,
  validVotesColumnComp,
  allVotesColumn,
  allVotesColumnComp,
  countStatus,
  ...ARTICLE_CONFIG.candidates
];

const colorSonstigeMin = '#f3f3f3';
const colorSonstigeMax = '#888';

// const colorSonstigeMinA = '#f3f3f3';
// const colorSonstigeMaxA = '#888';

export const partyConfig = {
  CDU: {
    min: '#d8d8d8',
    max: '#373737',
    name: 'CDU'
  },
  'Die.Linke': {
    min: '#fad5ed',
    max: '#96276E',
    name: 'Die Linke',
    shortname: 'Linke'
  },
  SPD: {
    min: '#ffe3e1',
    max: '#DB4240',
    name: 'SPD'
  },
  Grüne: {
    min: '#d6f3d4',
    max: '#4BA345',
    name: 'Grüne'
  },
  AfD: {
    min: '#cff6ff',
    max: '#34A3D2',
    name: 'AfD'
  },
  FDP: {
    min: '#fff7ce',
    max: '#F6BB00',
    name: 'FDP'
  },
  Piraten: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Piraten'
  },
  'Die.Partei': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Die Partei',
    shortname: 'Partei'
  },
  'Volt': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Volt',
    shortname: 'Volt'
  },
  'Tierschutz.hier': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Tierschutz hier',
    shortname: 'Tier'
  },
  ÖDP: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'ÖDP'
  },
  Gesundheitsforschung: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Gesundheitsforschung',
    shortname: 'Gesund.'
  },
  'Freie.Wähler': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Freie Wähler',
    shortname: 'FW'
  },
  'Die.Humanisten': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Humanisten'
  },
  Tierschutzpartei: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Tierschutzpartei',
    shortname: 'TSP'
  },
  sonstige: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Sonstige',
    shortname: 'Sonst.'
  },
  default: {
    min: colorSonstigeMin,
    max: colorSonstigeMax
  }
};

export function getLimits(values) {
  return Chroma.limits(values, 'q', 20);
}

export function getPartyColor(partyName) {
  return partyConfig[partyName] ? partyConfig[partyName] : partyConfig.default;
}

export function getPartyName(partyName) {
  return partyConfig[partyName] ? partyConfig[partyName].name : partyName;
}

export function getPartyNameShort(partyName, areaId = '') {
 /* if (
    partyName === 'CDU' &&
    areaId.substr(0, 2) === '09' &&
    baseconfig.app.unionShortName
  ) {
    return 'CSU';
   }*/
  if (partyConfig[partyName]) {
    return partyConfig[partyName].shortname
      ? partyConfig[partyName].shortname
      : partyConfig[partyName].name;
  }

  return partyName;
}
